import React, { useEffect, useState } from "react";
import Modal from "olive-react-myoneui/lib/Modal";
import Button from "olive-react-myoneui/lib/Button";
import messageLogo from "../../assets/images/logo-message.svg";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../utils/axios";
import { API_URL } from "../../constants/config";
import { setUserItemApprovalData } from "../../reducers/userItemApprovalSlice";

/* This modal opens up by clicking I'm interested button which is rendered by 'IaminterestedButton.js' component */
function IaminterestedModal(props) {
  const loggedInUser = useSelector((state) => state.user.user.logged_in_user);
  const currentItem = useSelector(
    (state) => state.userItemApproval.currentItem
  );

  const {
    apiRequestLoading,
    hideCancelButton,
    apiRequestTriggered,
    existingApprovalIds,
    iamInterestedModalTitle: title,
  } = useSelector((state) => state.userItemApproval);

  const interestCreationMessage = "Course interest created successfully";
  const dispatch = useDispatch();

  const goToLogin = () => {
    window.location.href = "/login";
    return;
  };

  const createInterest = async () => {
    if (apiRequestTriggered) {
      dispatch(setUserItemApprovalData({ showIamInterestedModal: false }));
      return;
    }
    dispatch(setUserItemApprovalData({ apiRequestLoading: true }));

    try {
      const response = await axios.post(
        `${API_URL}api/front_end/create_interest`,
        {
          item_id: currentItem.itemId,
          item_name: currentItem.itemName,
          item_type: currentItem.itemType,
        }
      );
      if (response?.data?.message && response.data.message == "Success") {
        dispatch(
          setUserItemApprovalData({
            iamInterestedModalTitle: interestCreationMessage,
            hideCancelButton: true,
          })
        );
      }
    } catch (err) {
      if (err?.response?.data?.data?.error) {
        dispatch(
          setUserItemApprovalData({
            iamInterestedModalTitle: err.response.data.data.error,
          })
        );
      }
    } finally {
      // document.getElementById(
      //   `iAmInterested-${currentItem.itemId}`
      // ).disabled = true;
      dispatch(
        setUserItemApprovalData({
          apiRequestLoading: false,
          apiRequestTriggered: true,
          existingApprovalIds: [...existingApprovalIds, currentItem.itemId],
        })
      );
    }
  };

  const renderModalBody = () => {
    if (!loggedInUser || loggedInUser["id"] == "0") {
      return (
        <div className="">
          <span>
            <img src={messageLogo} className="img-fluid icon-modal" />
          </span>
          <h1 className="heading-modal">{"You must be logged in!"}</h1>
          <p
            className="desc-modal"
            dangerouslySetInnerHTML={{ __html: props.successMessage }}
          ></p>
        </div>
      );
    }
    return (
      <div className="">
        <span>
          <img src={messageLogo} className="img-fluid icon-modal" />
        </span>
        <h1 className="heading-modal">{title}</h1>
        <p
          className="desc-modal"
          dangerouslySetInnerHTML={{ __html: props.successMessage }}
        ></p>
      </div>
    );
  };
  const renderModalFooter = () => {
    if (!loggedInUser || loggedInUser["id"] == "0") {
      return (
        <>
          <Button className="px-4" onClick={goToLogin}>
            Go to login
          </Button>
        </>
      );
    }
    return (
      <>
        {!hideCancelButton && (
          <Button className="px-4" onClick={props.onHide}>
            Cancel
          </Button>
        )}
        <Button variant="secondary" className="px-4" onClick={createInterest}>
          {apiRequestLoading ? "Working..." : "Ok"}
        </Button>
      </>
    );
  };
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      contentClassName="thankyou-modal"
      backdropClassName="backdrop-thankyou"
      backdrop="static"
    >
      <div className="course-reminder-content">
        <Modal.Body>{renderModalBody()}</Modal.Body>
        <Modal.Footer>{renderModalFooter()}</Modal.Footer>
      </div>
    </Modal>
  );
}

export default IaminterestedModal;
